export function getMaxHeight(parent: HTMLElement, customPadding = 0): string {
  const footerHeight = '100px';
  const mbsPageContentPaddingBottom = '21px';
  const mbsTable: HTMLElement = parent.querySelector('mbs-table');

  return `calc(100vh - ${mbsTable.offsetTop}px - ${footerHeight} - ${mbsPageContentPaddingBottom} - 7px + ${customPadding}px)`;
}
